import { X } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

type MobileActionsProps = {
  showClose?: boolean
  onClose?: () => void
}

export const MobileActions = ({ showClose = false, onClose }: MobileActionsProps) => {
  return (
    <div className="flex items-center gap-2 md:hidden">
      {showClose && onClose ? (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close terms"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border bg-background hover:bg-accent"
        >
          <X className="h-5 w-5" />
        </button>
      ) : null}
      <DropdownMenu>
        <DropdownMenuTrigger
          type="button"
          aria-label="Open menu"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border bg-background hover:bg-accent"
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-40">
          <DropdownMenuItem asChild>
            <a href="#/" className="font-medium">
              Builder
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href="#/terms">Terms</a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
